export const RESULTS_PER_PAGE = 25;
export const CATALOG_ITEM_RESULTS_PER_PAGE = 50;
